import styled from 'styled-components'
import { css, colors } from 'styles'

const translate = p => (p.position ? `translate(${p.x == 'left' ? 0 : -50}%, ${p.y == 'top' ? 0 : -50}%)` : '')

const StyledFab = styled.button`
  display: inline-block;
  vertical-align: middle;
  align-self: center;
  padding: 2.8rem;
  border-radius: 50%;
  border: none;
  box-shadow: 0 0 1rem ${colors.boxShadow};
  background: ${colors.mainBackground};
  z-index: 2;
  cursor: pointer;
  transform: ${translate} scale(1.01);
  transition: all 0.2s ease-in;

  &:focus,
  &:hover {
    outline: none;
    box-shadow: 0 0 1rem 0.4rem ${colors.main};
    transform: ${translate} scale(1.2);
  }

  ${p =>
    p.position &&
    css`
      position: absolute;
      left: ${{ left: 0, center: 50, right: 100 }[p.x]}%;
      top: ${{ top: 0, center: 50, bottom: 100 }[p.y]}%;
    `}

  i {
    width: 1em;
    line-height: 1;
    display: inline-block;
    text-align: center;
    transform: scale(1.4);
  }
`

export default StyledFab
